export default {
  data: () => ({
    tooltip: null,
    elements: null,
    clicked: false
  }),
  mounted() {
    this.initTooltip()
  },
  beforeUnmount() {
    clearTimeout(this.setupTimeout)
    this.destroyTooltip()
  },
  methods: {
    initTooltip() {
      if (this.$el.querySelectorAll && !this.elements && !this.tooltip) {
        this.elements = this.$el.querySelectorAll('[data-tooltip]')
        this.tooltip = document.querySelector('.tooltip-root')
        Array.from(this.elements).forEach((el) => {
          el.addEventListener('mouseenter', this.onMouseEnter.bind(this))
          el.addEventListener('mouseleave', this.onMouseLeave.bind(this))
          el.addEventListener('click', this.onMouseEnter.bind(this))
        })
        document.addEventListener('scroll', this.update.bind(this))
        document.addEventListener('click', this.onDocumentClick.bind(this))
        window.addEventListener('resize', this.update.bind(this))

        this.createTooltip()
      }
    },
    destroyTooltip() {
      if (this.elements) {
        Array.from(this.elements).forEach((el) => {
          el.removeEventListener('mouseenter', this.onMouseEnter.bind(this))
          el.removeEventListener('mouseleave', this.onMouseLeave.bind(this))
          el.removeEventListener('click', this.onMouseEnter.bind(this))
        })
      }
      document.removeEventListener('scroll', this.update.bind(this))
      document.removeEventListener('click', this.onDocumentClick.bind(this))
      window.removeEventListener('resize', this.update.bind(this))
    },
    createTooltip() {
      if (!this.tooltip) {
        this.tooltip = document.createElement('div')
        this.tooltip.classList.add('tooltip-root')
        this.tooltip.classList.add('edito')
        document.body.appendChild(this.tooltip)
      }
    },
    onMouseEnter(e) {
      console.log('onMouseEnter')
      if (e.type === 'click') {
        this.clicked = true
      }
      this.clearTooltips()
      e.target.setAttribute('data-tooltip-active', '')

      if (e.target.getAttribute('data-tooltip')) {
        this.tooltip.innerHTML = e.target.getAttribute('data-tooltip')

        if (e.target.classList.contains('white')) {
          this.tooltip.classList.add('--transverse')
        } else {
          this.tooltip.classList.remove('--transverse')
        }
      }

      this.tooltip.setAttribute('data-tooltip-show', '')
      this.update()
    },
    onMouseLeave() {
      if (!this.clicked) {
        this.setupTimeout = setTimeout(() => {
          this.tooltip.removeAttribute('data-tooltip-show')
        }, 500)
      }
    },
    onDocumentClick(e) {
      if (!JSON.stringify(e.target.dataset).includes('tooltip')) {
        if (!e.target.closest('.tooltip-root') && !e.target.hasAttribute('data-tooltip')) {
          this.clearTooltips()
        }
        this.clicked = false
      }
    },
    clearTooltips() {
      const els = document.querySelectorAll('[data-tooltip-active]')
      Array.from(els, (el) => el.removeAttribute('data-tooltip-active'))
      this.tooltip.removeAttribute('data-tooltip-show')
    },
    update() {
      const el = document.querySelector('[data-tooltip-active]')
      if (el) {
        const { top, right, bottom, left } = el.getBoundingClientRect()
        const ww = window.innerWidth
        const wh = window.innerHeight
        const tooltipWidth = this.tooltip.offsetWidth
        const tollerance = 10
        let topOffset = 0
        let leftOffset = 0
        this.tooltip.setAttribute('data-tooltip-position-x', 'center')
        this.tooltip.setAttribute('data-tooltip-position-y', 'bottom')
        if (ww - right < tooltipWidth + tollerance) {
          leftOffset = -tooltipWidth / 2 + tollerance
          this.tooltip.setAttribute('data-tooltip-position-x', 'right')
        }
        if (left < tooltipWidth + tollerance) {
          leftOffset = tooltipWidth / 2 - tollerance
          this.tooltip.setAttribute('data-tooltip-position-x', 'left')
        }
        if (wh - bottom < this.tooltip.offsetHeight) {
          topOffset = -this.tooltip.offsetHeight + top - bottom
          this.tooltip.setAttribute('data-tooltip-position-y', 'top')
        }
        this.tooltip.style.top = top + topOffset + 'px'
        this.tooltip.style.left = left + leftOffset + 'px'
      }
    }
  },
  watch: {
    $el() {
      this.initTooltip()
    }
  }
}
